import { cloneDeep } from 'lodash';

import { type BuilderComponent } from 'hb-builder/types';
import {
  type CommonSchemaBuilder,
  type PageSchemaBuilder,
  type EmailSchemaBuilder,
} from 'hb-builder/utils/migrate/schemas/types';
import { BUILDER_DOCUMENT_TYPE } from 'hb-react/backoffice/types/builder/builderDocument';
import { type DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

import schemasBothBuilders from './schemas/bothBuilders';
import schemasEmailBuilder from './schemas/emailBuilder';
import schemaOldToNewBuilder from './schemas/oldToNewBuilder';
import schemasPageBuilder from './schemas/pageBuilder';

// @TODO type schemas
const allSchemas = {
  all: [schemaOldToNewBuilder, ...schemasBothBuilders],
  [BUILDER_DOCUMENT_TYPE.EMAIL]: schemasEmailBuilder,
  [BUILDER_DOCUMENT_TYPE.PAGE]: schemasPageBuilder,
};

// @TODO type schemas
const updateSchema = (updates, item) => {
  if (updates) {
    Object.keys(updates).forEach((key) => {
      const update = updates[key](item[key], item);

      if (update === null) {
        delete item[key];
      } else if (!Array.isArray(update) && typeof update === 'object') {
        item[key] = updateSchema(update, item[key] || {});
      } else {
        item[key] = update;
      }
    });
  }

  return item;
};

const migrateDocument = ({
  document,
  type,
  ...rest
}:
  | CommonSchemaBuilder<BuilderComponent>
  | EmailSchemaBuilder<BuilderComponent>
  | PageSchemaBuilder<BuilderComponent>) => {
  const newDocument = cloneDeep(document);

  const traverse = (item: DocumentItem) => {
    Object.keys(allSchemas).forEach((schemaType) => {
      const schemas = allSchemas[schemaType];

      schemas.forEach((schema) => {
        if (schemaType === 'all' || type === schemaType) {
          schema = schema({
            document,
            ...rest,
          });

          if (schema) {
            item = updateSchema(schema[item.type], item);
          }
        }
      });
    });

    const { children } = item;

    if (children) {
      children.forEach((child, key) => {
        children[key] = traverse(child);
      });
    }

    return item;
  };

  return traverse(newDocument);
};

export default migrateDocument;
